export enum ProductFilterRecommendations {
	all = "all",
	only = "only",
	without = "without",
}

export enum ProductPriceCurrency {
	USD = "USD",
	EUR = "EUR",
	GBP = "GBP",
	AUD = "AUD",
}

export enum ProductSortBy {
	recommendedFirst = "recommendedFirst",
	relevant = "relevant",
	createdNewestToOldest = "created.desc",
	createdOldestToNewest = "created.asc",
	priceHighToLow = "list_price.desc",
	priceLowToHigh = "list_price.asc",
}

export enum ProductTypeFilterBy {
	mixed = "mixed",
	bundlesOnly = "bundlesOnly",
	freeAddOnOnly = "freeAddOnOnly",
}

export enum ProductCPAHiringGoalUnit {
	reviewedApplications = "reviewed_applications",
}
